import { render, staticRenderFns } from "./imgA.vue?vue&type=template&id=d46221bc"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d46221bc')) {
      api.createRecord('d46221bc', component.options)
    } else {
      api.reload('d46221bc', component.options)
    }
    module.hot.accept("./imgA.vue?vue&type=template&id=d46221bc", function () {
      api.rerender('d46221bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgA.vue"
export default component.exports